
























import { Component, Vue, Watch } from 'vue-property-decorator';
// import PaymentFilter from '@/helper/filters/PaymentFilter'
import AeroguestSupportComponent from '@/components/support/AeroguestSupportComponent.vue';
import ScreenShot from '@/shared/function/ScreenShot';
import Socket from '../../api/websocket/socket';
import LogService from '../../api/broadcast/LogService';

@Component({
  components: {
    AeroguestSupportComponent
  }
  // filters: PaymentFilter
})

export default class PaymentContainerView extends Vue {
  public showAeroguestSupport = false;
  public isScreenShotLoading: any = true;
  public titleValue = 'payment.choosePaymentMethod';
  public notification = false;
  public msgfromaeroguestsupport = '';

  // https://stackoverflow.com/questions/46402809/vuejs-event-on-route-change
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange (newVal: any) {
    const splitRoute = newVal.path.split('/');
    const lastValue = splitRoute[splitRoute.length - 1];
    if (lastValue === 'payment') {
      this.titleValue = 'checkin.payment';
    }
    if (lastValue === 'address' && splitRoute[splitRoute.length - 2] === 'step') {
      this.titleValue = 'bookAStay.billingAddress';
    }
    if (lastValue === 'cvc') {
      this.titleValue = 'payment.cvc.title';
    }
  }

  private created () {
    Socket.$on('message', this.msgHandler);
    Socket.$on('error', this.msgHandlerError);
  }

  private beforeDestroy () {
    Socket.$off('message', this.msgHandler);
  }

  private msgHandlerError (error: any) {
    LogService.LogInformation(`Socket Failed in PaymentContainerView.vue, Error: ${JSON.stringify(error)}`, {}, `${this.$route.params.identifier}:${this.$route.params.token}:${this.$route.params.bookingId}`);
  }

  private msgHandler (msg: any) {
    this.notification = true;
    this.msgfromaeroguestsupport = msg;
  }

  public async openAeroguestSupport () {
    this.showAeroguestSupport = true;
    this.isScreenShotLoading = await ScreenShot.openAeroguestSupport('Add payment card', this.$route.params.identifier, this.$route.params.token);
  }

  public closeAeroguestSupport () {
    this.showAeroguestSupport = false;
  }

  public closeBillingAddress (params: any) {
    if (params === 'bill') {
      this.$router.push({ name: 'bill-payment', params: { origin: 'billingAddress' } });
    } else {
      this.$router.go(-1);
    }
  }
}

